:host {
  display: inline-flex;
  flex-shrink: 0;
  white-space: nowrap;
}

.horizontalMark {
  --horizontal-mark-height: var(--srci-horizontal-mark-height, 16px);

  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  height: var(--horizontal-mark-height);
}

.horizontalMark--XS_12 {
  --horizontal-mark-height: var(--srci-horizontal-mark-height, 12px);
}

.horizontalMark--M_28 {
  --horizontal-mark-height: var(--srci-horizontal-mark-height, 28px);
}

.clickToPayMark,
.networkMarks {
  display: inline-flex;
  align-items: center;
  height: 100%;
}

.clickToPayMark {
  margin-right: calc(var(--horizontal-mark-height) / 4);
  padding-right: calc(var(--horizontal-mark-height) / 4);
  border-right: 1px solid #141413;
}

.networkMarks {
  gap: calc(var(--horizontal-mark-height) / 10);
}

.horizontalMarkImage {
  display: block;
  flex: 0 0 auto;
  width: auto;
  height: 100%;
}
